module.exports = __webpack_public_path__ + "static/img/chuzhongwuli3.80d991f2.jpg";